import dayjs from 'dayjs';
import { UserSubscription } from '@benzinga/subscription-manager';

interface OrderSummaryProps {
  checkout: any;
  discount?: string;
  subscriptionToPause?: UserSubscription | null;
  title: string;
}

export const OrderSummary: React.FC<OrderSummaryProps> = ({
  checkout,
  discount = '',
  subscriptionToPause = null,
  title,
}) => {
  const getCheckoutLines = () => {
    const lines: string[] = [];

    if (subscriptionToPause) {
      lines.push(
        subscriptionToPause.planName,
        `Pause starting
        ${
          subscriptionToPause.currentPeriodEnd
            ? dayjs(subscriptionToPause.currentPeriodEnd).format('MMM DD YYYY')
            : 'Today'
        }`,
      );
      return lines;
    }

    if (checkout) {
      const interval =
        checkout.plan?.intervalCount > 1
          ? `${checkout.plan.intervalCount} ${checkout.plan.interval}s`
          : checkout.plan.interval;
      lines.push(checkout.plan.name, `$${checkout.plan.price}/${interval}`);
    }
    if (discount) {
      const discountAmount = checkout?.price_data?.new_plan_price - checkout?.price_data?.immediate_amount;
      lines.push(`Discount - ${discount}`, `- $${(discountAmount / 100).toFixed(2)}`);
    }
    return lines;
  };

  const getTotal = () => {
    if (subscriptionToPause) return '$0.00';

    if (checkout) {
      return checkout.setup_fee === '$0.00' ? checkout.immediate_amount : checkout.setup_fee;
    }
    return '';
  };

  return (
    <div>
      <div className="bg-bzgrey-100/80 rounded-md p-2 my-2">
        <div>{title}</div>
        <div className="text-sm text-bzgrey-500 grid grid-cols-2 border-b py-2 gap-2">
          {getCheckoutLines().map((line, idx) => (
            <div className={idx % 2 !== 0 ? 'text-right' : ''} key={idx}>
              {line}
            </div>
          ))}
        </div>
        <div className="flex flex-row justify-between font-bold">
          <span>Total</span>
          <span>{getTotal()}</span>
        </div>
      </div>
    </div>
  );
};
